import React, { useEffect, useRef } from 'react';
import { TweenMax, Power3, TimelineLite } from 'gsap';
import '../styles/Hero.scss';

const Hero = () => {
    let app = useRef(null);
    let content = useRef(null);
    let headline = useRef(null);
    let subheadline = useRef(null);
    let cta = useRef(null);
    let circle = useRef(null);

    useEffect(() => {
        // Prevent initial flash
        TweenMax.to(app, 0, { css: { visibility: 'visible' } });

        const tl = new TimelineLite({ delay: 0.8 });

        tl.from(circle, 2, { opacity: 0, scale: 0, ease: Power3.easeOut })
            .from(headline.firstElementChild, 1.2, { y: 40, opacity: 0, ease: Power3.easeOut }, 0.2)
            .from(headline.lastElementChild, 1.2, { y: 40, opacity: 0, ease: Power3.easeOut }, 0.4)
            .from(subheadline, 1, { y: 20, opacity: 0, ease: Power3.easeOut }, 0.8)
            .from(cta, 1, { y: 20, opacity: 0, ease: Power3.easeOut }, 1);

        const handleMouseMove = (e) => {
            const { clientX, clientY } = e;
            const xPos = (clientX / window.innerWidth - 0.5) * 20;
            const yPos = (clientY / window.innerHeight - 0.5) * 20;

            TweenMax.to(circle, 1, {
                x: xPos * 2,
                y: yPos * 2,
                ease: Power3.easeOut
            });
            TweenMax.to(content, 1, {
                x: -xPos,
                y: -yPos,
                ease: Power3.easeOut
            });
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div className="hero" ref={el => app = el}>
            <div className="container hero-container">
                <div className="hero-content" ref={el => content = el}>
                    <div className="hero-text">
                        <h1 ref={el => headline = el}>
                            <div className="line">BEYOND THE</div>
                            <div className="line">HORIZON</div>
                        </h1>
                        <p ref={el => subheadline = el}>
                            Experience luxury space tourism like never before.
                            Journey to the stars in unparalleled comfort.
                        </p>
                        <button ref={el => cta = el} className="btn-explore">Start Your Journey</button>
                    </div>
                </div>
                <div className="hero-visuals">
                    <div className="circle-graphic" ref={el => circle = el}>
                        <div className="globe-wrap">
                            <div className="globe">
                                <div className="circle"></div>
                                <div className="circle-hor"></div>
                                <div className="circle-hor-middle"></div>
                                <div className="circle-hor-top"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
